import React, { useState } from 'react';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { IconButton } from 'shared/mui/IconButtons';
import { ListItemIcon, ListItemText } from 'shared/mui/List';
import { Menu } from 'shared/mui/Menu/Menu';
import { MenuItem } from 'shared/mui/MenuItem/MenuItem';

interface CommissionsTableTaskLaunchMenuProps {
  onView: () => void;
}

export const CommissionsTabsTaskLaunchMenu: React.FC<CommissionsTableTaskLaunchMenuProps> = ({
  onView,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleAction = () => {
    onView();
    handleMenuClose();
  };

  return (
    <>
      <IconButton onClick={handleMenuOpen} size="small">
        <MoreHorizIcon fontSize="small" />
      </IconButton>
      <Menu
        MenuListProps={{
          disablePadding: true,
          sx: {
            '& .MuiMenuItem-root': {
              margin: '0 !important',
            },
          },
        }}
        anchorEl={anchorEl}
        onClose={handleMenuClose}
        open={open}
        slotProps={{
          paper: {
            sx: {
              padding: 0,
            },
          },
        }}
      >
        <MenuItem onClick={handleAction}>
          <ListItemIcon>
            <VisibilityIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Просмотр" primaryTypographyProps={{ fontSize: 14 }} />
        </MenuItem>
      </Menu>
    </>
  );
};
